import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Button } from 'react-bootstrap'
import Layout from 'shared/layouts/NoIdentity'
import SelectWrapper from 'shared/components/SelectWrapper'
import { appName } from 'consts'
import useInit from './hooks/useInit'
import submitForm from './utils/submitForm'

const ChooseCustomer: React.FunctionComponent = () => {
  const [customers, setCustomers] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [errorMsg, setErrorMsg] = useState<string>('')

  const { control, handleSubmit, watch } = useForm()
  const selectedCustomer = watch('customer')

  useInit({ setCustomers })

  return (
    <Layout>
      <img src='/images/logo-colored.svg' className='logo-login' alt={appName} />
      <div className='color-overlay d-flex justify-content-center align-items-center'>
        <div className='rounded p-4 p-sm-3'>
          <h3 className='text-center mb-3'>Choose Customer</h3>

          {errorMsg && <p className='error'>{errorMsg}</p>}

          <form onSubmit={handleSubmit((data) => submitForm({ data, setIsLoading, setErrorMsg }))}>
            <SelectWrapper
              control={control}
              name='customer'
              options={customers}
              optionLabel='name'
              optionValue='id'
              defaultValue={null}
              isClearable={false}
            />
            <div className='text-center mt-3'>
              <Button
                type='submit'
                variant='primary'
                disabled={!selectedCustomer || isLoading}
              >
                {isLoading && (
                  <>
                    <span
                      className='spinner-border spinner-border-sm'
                      role='status'
                      aria-hidden='true'
                    ></span>
                    &nbsp;
                  </>
                )}
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  )
}

export default ChooseCustomer
